import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useMemo, useRef } from 'react';

import Sidebar from 'components/Sidebar';
import OffersSidebarBox from 'components/Sidebar/OffersSidebarBox';
import SidebarRelevantSubcategories from 'components/Sidebar/RelevantSubcategories';

import useAdBanner from 'hooks/useAdBanner';

const SponsorAd = dynamic(() => import('./SponsorAd'));

const FIRST_AD_POSITION = 1;
const SECOND_AD_POSITION = 2;

const ArticleSidebar = ({ gaEventCategory, sidebarAds }) => {
  const { getAdBannerWithHigherVisibilityPriority } = useAdBanner();
  const firstSponsorAdRef = useRef(null);
  const offersSidebarBoxRef = useRef(null);
  const relevantSubcategoriesRef = useRef(null);

  const [firstAd, secondAd] = useMemo(
    () => [
      getAdBannerWithHigherVisibilityPriority(sidebarAds, FIRST_AD_POSITION),
      getAdBannerWithHigherVisibilityPriority(sidebarAds, SECOND_AD_POSITION),
    ],
    [sidebarAds, getAdBannerWithHigherVisibilityPriority]
  );

  return (
    <Sidebar
      className="col-span-4 gap-y-4 xl:col-span-3"
      refsToBeIgnoredBeforeFixing={[
        firstSponsorAdRef,
        offersSidebarBoxRef,
        relevantSubcategoriesRef,
      ]}
    >
      {firstAd && (
        <SponsorAd
          ref={firstSponsorAdRef}
          ad={firstAd}
          gaEventCategory={gaEventCategory}
          position={FIRST_AD_POSITION}
        />
      )}
      <OffersSidebarBox ref={offersSidebarBoxRef} />
      <SidebarRelevantSubcategories ref={relevantSubcategoriesRef} />
      {secondAd && (
        <SponsorAd
          ad={secondAd}
          gaEventCategory={gaEventCategory}
          position={SECOND_AD_POSITION}
        />
      )}
    </Sidebar>
  );
};

ArticleSidebar.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  sidebarAds: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string.isRequired,
      id: PropTypes.number.isRequired,
      image: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      visibility: PropTypes.string.isRequired,
    })
  ),
};

export default ArticleSidebar;
